import React from "react";
import P2PPrices from "../components/P2PPrices";
import styles from "./P2PPage.module.css";

export default function P2PPage() {
  return (
    <main className={styles.page}>
      <h2 style={{ marginBottom: 16 }}>Mercado P2P</h2>
      <P2PPrices />
    </main>
  );
}
